
// export const IPUrl ="http://localhost:8500/";

// export const ProfileUrl = "http://localhost:8500/";
// export const IPUrl ="http://192.168.43.100:8500/";

// export const ProfileUrl = "http://192.168.43.100:8500/";

// export const ProfileUrl = "http://192.168.100.110:8500/";

// export const IPUrl ="http://192.168.100.110:8500/";
export const ProfileUrl = "https://portal.myamol.ir/";

export const IPUrl ="https://portal.myamol.ir/";


